import { personTypeUuids } from "../helper";

export const useSearchFilterManager = ({
  getFilter,
  setFilter,
  getTags,
  setTags,
  onFilter,
}) => {
  const talentFilter = getFilter() || {};
  const talentFilterTags = getTags() || [];

  const apply = (postObj, tags) => {
    setFilter(postObj);
    setTags(tags);
    onFilter(postObj);
  };

  const buildBase = () => ({
    ...(talentFilter || {}),
    person_type_uuids:
      talentFilter?.person_type_uuids || [personTypeUuids],
  });

  const addFilter = (type, payload, searchText) => {
    let base = buildBase();

    if (searchText) base.search_field = searchText;

    switch (type) {
      case "search":
        return apply(
          { ...payload.base },
          talentFilterTags
        );

      case "location":
        return apply(
          { ...base, location: payload.location },
          payload.tags
        );

      case "rating":
        return apply(
          { ...base, company_rating: payload.company_rating },
          payload.tags
        );

      case "roles":
        return apply(
          { ...base, event_roles: payload.rolesPayload },
          payload.tags
        );

      case "skills":
        return apply(
          { ...base, skills: payload.skillsPayload },
          payload.tags
        );

      default: {
        const existing = (base.person_attributes || []).filter(Boolean);

        const cleaned = existing.filter(
          attribute => attribute &&
            attribute.person_attribute_uuid !==
            payload.attribute.person_attribute_uuid
        );

        return apply(
          {
            ...base,
            person_attributes: [...cleaned, payload.attribute],
          },
          payload.tags
        );
      }
    }
  };

  const removeFilter = (uuid) => {
    let postObj = { ...(talentFilter || {}) };

    if (uuid === "rating") delete postObj.company_rating;
    else if (uuid === "skills") delete postObj.skills;
    else if (uuid === "roles") delete postObj.event_roles;
    else if (["city", "state", "radius"].includes(uuid))
      delete postObj.location;
    else {
      postObj.person_attributes =
        (postObj.person_attributes || [])
          .filter(Boolean)
          .filter(attribute => attribute && attribute.person_attribute_uuid !== uuid);

      if (!postObj.person_attributes.length)
        delete postObj.person_attributes;
    }

    const tags = talentFilterTags.filter(t => t.uuid !== uuid);

    if (Object.keys(postObj).length === 1) postObj = {};

    setFilter(postObj);
    setTags(tags);
    onFilter(postObj);
  };

  const clearAll = () => {
    setFilter({});
    setTags([]);
    onFilter(null);
  };

  return {
    addFilter,
    removeFilter,
    clearAll,
    talentFilter,
    talentFilterTags,
  };
};
